/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemFeatureModel } from '../../models/system-feature-model';

export interface GetSystemFeatures$Params {
}

export function GetSystemFeatures(http: HttpClient, rootUrl: string, params?: GetSystemFeatures$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SystemFeatureModel>>> {
  const rb = new RequestBuilder(rootUrl, GetSystemFeatures.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SystemFeatureModel>>;
    })
  );
}

GetSystemFeatures.PATH = '/api/SystemSettings/GetSystemFeatures';
